export const Role = {
  ADMIN: "ADMINISTRADOR",
  USER: "USUARIO",
  FINANCEIRO: "FINANCEIRO",
  CORRETOR: "CORRETOR",
  CONSTRUTORA: "CONSTRUTORA"
}

export const FullAccess = [
  Role.ADMIN,
  Role.CORRETOR,
  Role.CORRETOR,
  Role.FINANCEIRO,
  Role.USER,
  Role.CONSTRUTORA
]

export const RouteUnAuthorizedSigned = ["/", "/registro", "/finalizar-cadastro"]
